<script setup>
/* eslint-disable */
import { ref, computed } from "vue";
import { useSocketStore } from '@/stores/socket';

const socketStore = useSocketStore();
const isDevelopment = ref(process.env.VUE_APP_MODE == 'DEBUG');
const isExpanded = ref(false);

const socketConnected = computed(() => {
	return socketStore.connected;
});
</script>

<template>
	<!-- Floating Socket Debug Panel (Local / Dev only) -->
	<div v-if="isDevelopment" class="socket-debug-widget" :class="{ 'expanded': isExpanded }">
		<div class="debug-header" @click="isExpanded = !isExpanded">
			<span class="debug-title">🔌 Socket Debug (Runs: {{ socketStore.connection_times }})</span>
			<span class="status-dot" :class="{ 'connected': socketConnected }"></span>
		</div>
		<div v-if="isExpanded" class="debug-body">
			<div class="debug-row">
				<span class="label">Status:</span>
				<span class="value" :class="{ 'text-success': socketConnected, 'text-danger': !socketConnected }">
					{{ socketConnected ? 'Connected' : 'Disconnected' }}
				</span>
			</div>
			<div class="debug-row">
				<span class="label">Errors Prevented:</span>
				<span class="value highlight">{{ socketStore.errors_caught || 0 }}</span>
			</div>
			<div class="debug-row log-row">
				<span class="label">Log:</span>
				<span class="value log-text">{{ socketStore.debug }}</span>
			</div>
			<div class="debug-actions">
				<button class="debug-btn" @click="socketStore.socket ? socketStore.socket.connect() : null">Connect</button>
				<button class="debug-btn btn-danger" @click="socketStore.socket ? socketStore.socket.disconnect() : null">Disconnect</button>
				<button class="debug-btn btn-secondary" @click="socketStore.joinOldChanels()">Rejoin</button>
			</div>
		</div>
	</div>
</template>

<style scoped>
.socket-debug-widget {
	position: fixed;
	bottom: 80px;
	left: 20px;
	z-index: 99999;
	background: rgba(30, 30, 30, 0.85);
	backdrop-filter: blur(10px);
	border: 1px solid rgba(255, 255, 255, 0.1);
	border-radius: 8px;
	color: #fff;
	font-family: monospace;
	font-size: 12px;
	box-shadow: 0 4px 20px rgba(0, 0, 0, 0.5);
	width: 280px;
	transition: all 0.3s ease;
	user-select: none;
}
.socket-debug-widget.expanded {
	width: 320px;
}
.debug-header {
	padding: 10px 12px;
	display: flex;
	justify-content: space-between;
	align-items: center;
	cursor: pointer;
	border-bottom: 1px solid rgba(255, 255, 255, 0.05);
}
.debug-title {
	font-weight: bold;
}
.status-dot {
	width: 8px;
	height: 8px;
	border-radius: 50%;
	background: #ff4d4d;
	box-shadow: 0 0 8px #ff4d4d;
	transition: all 0.3s ease;
}
.status-dot.connected {
	background: #2ecc71;
	box-shadow: 0 0 8px #2ecc71;
}
.debug-body {
	padding: 12px;
	display: flex;
	flex-direction: column;
	gap: 8px;
}
.debug-row {
	display: flex;
	justify-content: space-between;
	align-items: flex-start;
}
.log-row {
	flex-direction: column;
	gap: 4px;
}
.label {
	color: #888;
}
.value {
	word-break: break-all;
}
.highlight {
	color: #f39c12;
	font-weight: bold;
}
.text-success {
	color: #2ecc71;
}
.text-danger {
	color: #e74c3c;
}
.log-text {
	background: rgba(0, 0, 0, 0.3);
	padding: 6px;
	border-radius: 4px;
	width: 100%;
	max-height: 80px;
	overflow-y: auto;
	font-size: 10px;
	color: #3498db;
	box-sizing: border-box;
}
.debug-actions {
	display: grid;
	grid-template-columns: 1fr 1fr 1fr;
	gap: 6px;
	margin-top: 6px;
}
.debug-btn {
	background: #2980b9;
	border: none;
	color: white;
	padding: 6px 4px;
	border-radius: 4px;
	cursor: pointer;
	font-size: 10px;
	text-align: center;
	font-weight: bold;
	transition: background 0.2s;
}
.debug-btn:hover {
	background: #3498db;
}
.debug-btn.btn-danger {
	background: #c0392b;
}
.debug-btn.btn-danger:hover {
	background: #e74c3c;
}
.debug-btn.btn-secondary {
	background: #7f8c8d;
}
.debug-btn.btn-secondary:hover {
	background: #95a5a6;
}
</style>
